import React from 'react';
import { UserExam } from '../../../types/User';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { hapticsImpactLight } from '../../../utils/haptics';
import TriangleRight from '../../../assets/icons/triangle-right.svg';
import TriangleDown from '../../../assets/icons/triangle-down.svg';
import { Check } from 'react-feather';

interface ExamAccordionProps {
  availableExams: UserExam[];
  onChange?: (examId: string) => void;
  onClick?: (examId: string) => void;
  createSchoolExamClick?: () => void;
  isCreatingSchoolExam?: boolean;
  hideCustomExam?: boolean;
}

const ExamAccordion: React.FC<ExamAccordionProps> = ({
  availableExams,
  onChange,
  onClick,
  createSchoolExamClick,
  isCreatingSchoolExam,
  hideCustomExam,
}) => {
  const prioritizeExams = () => {
    const stepExams = availableExams.filter(
      (exam) => exam.name === 'USMLE Step 1' || exam.name === 'USMLE Step 2'
    );
    const shelfExams = availableExams.filter(
      (exam) =>
        exam.name !== 'USMLE Step 1' &&
        exam.name !== 'USMLE Step 2' &&
        exam.type === 'NBME'
    );
    stepExams.sort((a, b) => a.name.localeCompare(b.name));
    shelfExams.sort((a, b) => a.name.localeCompare(b.name));
    return { stepExams, shelfExams };
  };

  const sortedExams = prioritizeExams();

  return (
    <form className="exam-accordion">
      {createSchoolExamClick && !hideCustomExam && (
        <div
          className="button button--glass button--create-my-own"
          role="button"
          tabIndex={0}
          onClick={createSchoolExamClick}
        >
          <span>School Exam</span>
          {/* <span className="beta-badge">BETA</span> */}
          {isCreatingSchoolExam && <Check />}
        </div>
      )}
      {/* Step Exams Accordion */}
      <Accordion>
        <AccordionSummary
          aria-controls="step-exam-content"
          id="step-exam-header"
          sx={{ padding: '0', minHeight: '0 !important' }}
          onClick={() => {
            hapticsImpactLight();
          }}
        >
          <label>
            <div className="option" style={{ justifyContent: 'flex-start' }}>
              <img
                className="expand-icon expand-icon--closed"
                src={TriangleRight}
                alt=""
              />
              <img
                className="expand-icon expand-icon--open"
                src={TriangleDown}
                alt=""
              />
              <span>Step Exams</span>
            </div>
          </label>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: '0' }}>
          {sortedExams.stepExams.map((exam: UserExam) => {
            return (
              <label htmlFor={exam.id} key={exam.id}>
                <input
                  id={exam.id}
                  type="radio"
                  name="exam"
                  value={exam.id}
                  onChange={() => {
                    if (onChange) {
                      onChange(exam.id);
                    }
                  }}
                  onClick={(e) => {
                    if (onClick) {
                      onClick((e.target as HTMLInputElement).value);
                    }
                    hapticsImpactLight();
                  }}
                />
                <div className="option">
                  <span>{exam.name}</span>
                  <Check />
                </div>
              </label>
            );
          })}
        </AccordionDetails>
      </Accordion>
      {/* Shelf Exams Accordion */}
      <Accordion>
        <AccordionSummary
          aria-controls="exam-content"
          id="exam-header"
          sx={{ padding: '0', minHeight: '0 !important' }}
          onClick={() => {
            hapticsImpactLight();
          }}
        >
          <label>
            <div className="option" style={{ justifyContent: 'flex-start' }}>
              <img
                className="expand-icon expand-icon--closed"
                src={TriangleRight}
                alt=""
              />
              <img
                className="expand-icon expand-icon--open"
                src={TriangleDown}
                alt=""
              />
              <span>Shelf Exams</span>
            </div>
          </label>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: '0' }}>
          {sortedExams.shelfExams.map((exam: UserExam) => {
            return (
              <label htmlFor={exam.id} key={exam.id}>
                <input
                  id={exam.id}
                  type="radio"
                  name="exam"
                  value={exam.id}
                  onChange={() => {
                    if (onChange) {
                      onChange(exam.id);
                    }
                  }}
                  onClick={(e) => {
                    if (onClick) {
                      onClick((e.target as HTMLInputElement).value);
                    }
                  }}
                />
                <div className="option">
                  <span>{exam.name}</span>
                  <Check />
                </div>
              </label>
            );
          })}
        </AccordionDetails>
      </Accordion>
    </form>
  );
};

export default ExamAccordion;
